import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import ExportableTable from 'containers/tables/ExportableTable';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import CellDiv from 'components/molecules/tables/components/CellDiv';
import helpers from 'helpers';
import Pagination from 'components/molecules/tables/components/Pagination';

class ExpandedDonutTable extends Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const { data, title, exportName, y, total } = this.props;
        const rowsPerPage = 11;
        return (
            <ContentTile padding={helpers.contentPadding('table')}>
                <ContentHeader tableData={data} exportName={exportName} type={'table'}>{title}</ContentHeader>
                <ExportableTable
                    key={1}
                    title={title}
                    exportName={exportName}
                    data={data}
                    columns={[
                        {
                            Header: 'Name',
                            accessor: 'name',
                            Cell: row => <CellDiv value={row.value} />,
                        },
                        {
                            Header: `Percentage of ${helpers.convertToDisplayValue(y)}`,
                            accessor: 'y',
                            type: 'percentage',
                            Cell: row => <CellDiv value={row.value} type={'percentage'} />,
                        },
                        total ?
                            {
                                Header: 'Amount',
                                accessor: 'y',
                                Cell: row => <CellDiv
                                    // Calculate dollar amount from percentage and reformat to currency by replacing
                                    // every three digits from the left with ',' until a decimal point is reached
                                    value={`$ ${(row.value * total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`}
                                    style={{ textAlign: 'right' }} />,
                            } : {},
                    ]}
                    getTheadThProps={() => ({ style: { outline: 0 } })}
                    getTrProps={() => ({ style: { fontSize: '11px', lineHeight: '10px' } })}
                    defaultSorted={[
                        {
                            id: 'y',
                            desc: true
                        }
                    ]}
                    showPagination={data.length > rowsPerPage}
                    hidePageDropDown
                    PaginationComponent={Pagination}
                    defaultPageSize={rowsPerPage}
                    minRows={rowsPerPage}
                    className="-highlight"
                />
            </ContentTile>
        );
    }
}

ExpandedDonutTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        y: PropTypes.number,
    })),
    title: PropTypes.string.isRequired
};

export default ExpandedDonutTable;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/ExpandedDonutTable.js